module.exports = __webpack_public_path__ + "img/timesmuseum_qrcode.3fbe5f5f.jpg";